import ApiService from '../../components/api_services/apiService.jsx';

import { ReactComponent as Edit } from '../../components/icons/edit.svg';
import { toggleCheckedItem, toggleEditModal, setPage, to, setSortListEndpoint } from '../../store/trainingsTabSlice';

import ClasicArrowDown from '../../components/icons/clasic-arrow-down.jsx';
import ClasicArrowUp from '../../components/icons/clasic-arrow-up.jsx';

import store from '../../store/store.js';

export const fetchTrainings = async (sortBy, sortDirection, keyword, currentPage, dispatch, setMaxPages, setRows, checkedItems) => {
  try {
    const checkedSortBy = sortBy === null || sortDirection === null ? null : sortBy;
    const checkedSortDirection = sortBy === null || sortDirection === null ? null : sortDirection;
    const response = await ApiService.getTrainings(checkedSortBy, checkedSortDirection, keyword, currentPage - 1);

    console.log(response);
    dispatch(setMaxPages(response.totalPages));
    
    // Pobierz ikony dla wszystkich treningów
    const trainingsWithIcons = await Promise.all(
      response.content.map(async (training) => {
        const sportIcon = await ApiService.getSportIcon(training.sportId);
        return { ...training, sportIcon };
      })
    );
    
    const mappedRows = trainingsWithIcons.map((training) => [
      <input
        type="checkbox"
        checked={checkedItems.includes(training.id)}
        onChange={() => dispatch(toggleCheckedItem(training.id))}
      />,
      training.id,
      training.title,
      training.planedStartDate ? `${training.planedStartDate.split('T')[0]} ${training.planedStartDate.split('T')[1].substring(0, 5)}` : '',
      <img src={training.sportIcon} alt="Sport icon" />,
      training.trainingStatus,
      " "
    ]);
    
    setRows(mappedRows);
    let currentPageState = store.getState().sports.currentPage;
    keyword && currentPageState !== 1 && dispatch(setPage(1));
  } catch (error) {
    console.error('Błąd podczas pobierania danych:', error);
  }
};